import { Pipe, PipeTransform } from '@angular/core';
import { Currency } from '../services/currency.service';
import { CurrencyUtils } from '../utils/currency.utils';

@Pipe({
    name: 'currencySymbol',
    standalone: true,
})
export class CurrencySymbolPipe implements PipeTransform {
    transform(currency: Currency): string {
        return CurrencyUtils.getCurrencySymbol(currency);
    }
}
